import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute";
import FormPage from "./pages/FormPage";
import FormsLandingPage from "./pages/FormsLandingPage";
import ApplicationStatusPage from "./pages/ApplicationStatusPage";
import QRScannerPage from "./pages/QRScannerPage";
import QRDisplayPage from "./pages/QRDisplayPage";
import AdminPage from "./pages/AdminPage";
import AdminJudgePage from "./pages/AdminJudgePage";
import AdminApplicantsPage from "./pages/AdminApplicantsPage";
import AdminApplicationViewPage from "./pages/AdminApplicationViewPage";
import AdminRolesPage from "./pages/AdminRolesPage";
import DuQuantumPortalPage from "./pages/DuQuantumPortalPage";
import DuQuantumAccountSetupPage from "./pages/DuQuantumAccountSetupPage";
import DuQuantumAdminPage from "./pages/DuQuantumAdminPage";
import DuQuantumScannerPage from "./pages/DuQuantumScannerPage";
import "./App.css";
import { FullPageLoadingSpinner } from "./components/FullPageLoadingSpinner";
import NotFound from "./components/404page";
import { useInitializeAuth } from "./utils/authUtils";

const DynamicFormPage = () => {
  const params = new URLSearchParams(window.location.search);
  const formKey = params.get("formKey");

  if (!formKey) {
    return <NotFound />;
  }

  return <FormPage formKey={formKey} />;
};

function App() {
  const { isLoading } = useAuth0();
  useInitializeAuth();

  if (isLoading) {
    return <FullPageLoadingSpinner />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/application"
          element={
            <ProtectedRoute>
              <FormsLandingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/form"
          element={
            <ProtectedRoute>
              <DynamicFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/status"
          element={
            <ProtectedRoute>
              <ApplicationStatusPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/qr-scanner"
          element={
            <ProtectedRoute>
              <QRScannerPage />
            </ProtectedRoute>
          }
        />
        <Route path="/qr" element={<QRDisplayPage />} />
        <Route
          path="/events/duquantum-2026/account-setup"
          element={<DuQuantumAccountSetupPage />}
        />
        <Route
          path="/events/duquantum-2026"
          element={
            <ProtectedRoute>
              <DuQuantumPortalPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/judge"
          element={
            <ProtectedRoute>
              <AdminJudgePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/applicants"
          element={
            <ProtectedRoute>
              <AdminApplicantsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/application/:appId"
          element={
            <ProtectedRoute>
              <AdminApplicationViewPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/roles"
          element={
            <ProtectedRoute>
              <AdminRolesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events/duquantum-2026/attendees"
          element={
            <ProtectedRoute>
              <DuQuantumAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events/duquantum-2026/check-in"
          element={
            <ProtectedRoute>
              <DuQuantumScannerPage />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
